import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./pages/layout/Layout";
import Chat from "./pages/chat/Chat";
import { Error } from "./pages/error/Error";
import { LoadingSpinner } from "./components/LoadingSpinner";
import AppProvider from "./context/AppProvider";
import { CookiesProvider } from "react-cookie";
import { HelmetProvider } from "react-helmet-async";
import "@clovirtualfashion/components/dist/styles/globals.css";
import "./index.css";

if (import.meta.env.MODE === "prod") {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

const router = createBrowserRouter([
  {
    element: <Layout />,
    errorElement: <Error />,
    children: [
      {
        path: "/",
        element: <Chat />,
      },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <HelmetProvider>
    <CookiesProvider defaultSetOptions={{ path: "/" }}>
      <AppProvider>
        <RouterProvider router={router} fallbackElement={<LoadingSpinner />} />
      </AppProvider>
    </CookiesProvider>
  </HelmetProvider>,
);
